module.exports = __webpack_public_path__ + "img/4g室内摄像机.f468b9b0.jpg";